import { Button, FormConfig, Input } from '@lbcamden/lib-react';
import { DateTime, DurationLikeObject } from 'luxon';
import { z } from 'zod';

import { actionsRecommendationsSchema } from '~/common/schemas/pcfra';
import { PcfraRecommendation } from '~/common/types/pcfra';

import { SectionHeading } from '../common.styled';
import { ReviewDateContainer, ReviewDateOptions } from './ActionsRecommendations.styled';
import { RecommendationList } from './RecommendationList';

export type ActionsRecommendationsFormValues = z.infer<typeof actionsRecommendationsSchema>;

const reviewDateFromPeriod = (period: DurationLikeObject) =>
  DateTime.now().plus(period).toISODate();

const reviewDateOptions: { label: string; period: DurationLikeObject }[] = [
  { label: '3 months', period: { months: 3 } },
  { label: '6 months', period: { months: 6 } },
  { label: '12 months', period: { year: 1 } },
  { label: '24 months', period: { year: 2 } },
];

export const actionsRecommendationsFormConfig: FormConfig<ActionsRecommendationsFormValues> = {
  fieldConfigs: {
    recommendations: {
      label: <SectionHeading>Recommendations</SectionHeading>,
      hideFieldErrorMessage: true,
      customRenderFn: (value, onChange, _config, errorDetails) => (
        <RecommendationList
          initialValue={value}
          errorDetails={errorDetails}
          onChange={(newValue) => onChange(newValue as PcfraRecommendation[])}
        />
      ),
    },
    comments: {
      type: 'textarea',
      label: 'Additional comments (optional)',
    },
    reviewDate: {
      label: 'Recommended review date',
      customRenderFn: (value, onChange, { key }, errorDetails) => (
        <ReviewDateContainer>
          <ReviewDateOptions>
            {reviewDateOptions.map(({ label, period }) => (
              <Button
                key={label}
                $color="secondary"
                onClick={() => onChange(reviewDateFromPeriod(period))}
              >
                {label}
              </Button>
            ))}
          </ReviewDateOptions>
          <Input
            id={key}
            name={key}
            type="date"
            $error={!!errorDetails?.length}
            min={DateTime.now().toISODate()}
            value={value ?? ''}
            onChange={(e) => onChange(e.target.value)}
          />
        </ReviewDateContainer>
      ),
    },
  },
};
